import React, { useEffect } from "react";
import {DateTime, FormatPrice, FullDate, ShortDate} from "../tools/delivery-tools";
import { REDUCTION_TYPE } from "../../helpers/delivery.helper";
import { Row, Col } from "antd";
import FieldBlock from "../field-block";
import { DatePicker } from "antd";
import { multimodalFlags } from "../../helpers/delivery.helper";
import { userServices } from "../../services";
import i18n from "../../i18n";

import {
    DELIVERY_AGREED,
    DELIVERY_AWAITING_LOADING,
    DELIVERY_BOOKED,
    DELIVERY_ENROUTE,
    DELIVERY_LOADING
} from "../../helpers/delivery_status.helper";

export const Multimodal = {
    equipments,
    weight,
    equipmentsByPoint,
    orderFields,
    flagsInfo,
    cost,
    costForOrder
}

function costForOrder({delivery}) {
    const rate = delivery.Multimodal.rate.map((elem, index) => {
        return (
            <span>{elem.symbol} = {elem.value}₽</span>
        );
    });

    return (
        <>
            <div className='delivery-item-title'>
                Ставка:
            </div>
            <div>
                <p>
                    <dl>
                        <dt>{i18n.t('Общая стоимость')}</dt> 
                        <dd>{delivery.Multimodal.actualCost || delivery.Multimodal.totalCost}<span>₽</span></dd>
                    </dl>
                </p>
            </div>
        </>
    );
}

function cost({ delivery, permissions }) {
    const user = userServices.getUser();
    if(delivery.Status === DELIVERY_AWAITING_LOADING || delivery.Status === DELIVERY_ENROUTE || delivery.Status === DELIVERY_LOADING || delivery.Status === DELIVERY_AGREED
        || (user.info.userType === 'inner' && delivery.Status === DELIVERY_BOOKED)) {
        return null;
    }

    const canCreateOrder = (delivery.Status === DELIVERY_BOOKED && user.info.userType === "carrier") || user.info.userType === "inner" || (permissions !== undefined && permissions.IsCanCreateOrder !== false);

    return (
        <div className="informer-item pricer">
            <div className="h-informer">{i18n.t('Общая стоимость')}</div>
            <div className="b-informer">
                <p>{delivery.Multimodal.actualCost || delivery.Multimodal.totalCost || '-'} <span>₽</span></p>
            </div>
        </div>
    );
}

function equipments({ data }) {

    const contArray = data.commonInfo.types ?
        Array.isArray(data.commonInfo.types) ?  data.commonInfo.types : Object.values(data.commonInfo.types) :
        null;

    const typesInfo = contArray ? contArray.map((elem, key) => {
        return (
            <div key={key}>
                <div className="ls">{elem.title} - {elem.count}шт.</div>
            </div>
        );
    }) : null;

    let info = [];
        info.push(<>
        <div className="col-pos-top ">
            <div className="informer-item">
            <div className="h-informer">Составляющие</div>
            <div className="b-informer">
                <div className="inf">{typesInfo}</div>
            </div>
            </div>
        </div>
        </>);
    return info;
}

function weight ({ data }) {
    let info = [];

    if(data.commonInfo.volume) {
        info.push(<>
            <div className="col-pos-bot">
                <div className="double-bot clrfx">
                    <div className="informer-item">
                        <div className="h-informer">{i18n.t('Общий объём')}</div>
                        <div className="b-informer">
                        <div className="inf">{data.commonInfo.volume} м<sup>3</sup></div>
                        </div>
                    </div>
                    <div className="informer-item">
                        <div className="h-informer">{i18n.t('Общий вес')}</div>
                        <div className="b-informer">
                        <div className="inf">{(data.commonInfo.weight / 1000).toFixed(2)} т.</div>
                        </div>
                    </div>
                </div>
            </div>
        </>);
    } else {
        info.push(<>
            <div className="col-pos-bot ">
            <div className="informer-item">
                <div className="h-informer">Общий вес</div>
                <div className="b-informer">
                <div className="inf">{(data.commonInfo.weight / 1000).toFixed(2)} т.</div>
                </div>
            </div>
            </div>
        </>);
    }

    return info;
}

function equipmentsByPoint({ delivery, guid }) {
    if(!delivery.IsMultimodal) {
        return null;
    }

    const data = delivery.Multimodal;
    const contArray = data.equipments ?
        Array.isArray(data.equipments) ?  data.equipments : Object.values(data.equipments) :
        null;
    
    return contArray.filter((cont) => {return guid in cont.points}).map((elem, key) => {
        return (
            <div key={key}>
                <div className="ls">{elem.type} - {elem.points[guid].weight || elem.weight}кг.</div>
            </div>
        );
    });
}

function orderFields({delivery, dateDeparture, setDateDeparture, getFieldErrors, localeDatePicker}) {
    const tnvdCodes = delivery.Multimodal.tnvdCodes.join(", ");

    return (
        <Row gutter={[24, 26]}>
            <Col lg={24} md={24} sm={24} xs={24}>
                    <span class={'form-field-label'}>Коды ТН ВЭД</span>
                    <p>{tnvdCodes}</p>
            </Col>
        </Row>
    );
}

function flagsInfo({delivery}) {
    let info = [];
    
    if(delivery.Multimodal && delivery.Multimodal.flags) {
        Object.entries(delivery.Multimodal.flags).map((elem, key) => {
            info.push(<p><b>{multimodalFlags[elem[0]]}:</b> {elem[1] ? 'Да' : 'Нет'}</p>);
        });
    }

    return info;
}